module.exports = __webpack_public_path__ + "media/images/icons/material/flame-6a8d964e8a7746b16a337a63d94abb34.svg";